export const BRAND_PROMO = 'brandpromotion';
export const RETAILER_PROMO = 'retailerpromotion';
export const PROMOTION = 'promotion';
export const REBATE_PROMOTION = 'rebatepromotion';
